import { render, staticRenderFns } from "./rooms.vue?vue&type=template&id=b0b32ea8&scoped=true"
import script from "./rooms.vue?vue&type=script&lang=js"
export * from "./rooms.vue?vue&type=script&lang=js"
import style0 from "./rooms.vue?vue&type=style&index=0&id=b0b32ea8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b32ea8",
  null
  
)

export default component.exports